import React from 'react'
import { Feature1, Feature2 } from '../Reusable/Feature1'

const Features = () => {
    return (
        <div className='relative flex bg-[#161616] flex-col lg:px-[8%] px-[4%] lg:pt-[6%] py-[3%]'>
            <div className='absolute w-[400px] h-[400px] left-[-100px] bottom-[-300px] bg-blue-400 bg-opacity-30 rounded-full blur-3xl'></div>
            {/* <div className='absolute w-[400px] h-[400px] right-[-100px] top-[-300px] bg-blue-400 bg-opacity-30 rounded-full blur-3xl'></div> */}
            <div data-aos="zoom-in-up" className='flex w-full items-center justify-center'>
                <div className='lg:w-[40%] gap-4 w-full flex flex-col items-center justify-center'>
                    <p className='lg:text-[55px] text-[30px] text-white font-semibold '>What We <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                    Offer
                    </span></p>
                    <p className='lg:text-[15px] text-[13px] text-[#ffffff] text-center'>Join the agricultural revolution with Blockfarms — leveraging blockchain to enhance farm-to-table traceability, ensure fair pricing, and promote sustainable farming practices globally.</p>
                </div>
            </div>
            <p className='text-[130px] z-[100] lg:block hidden top-1 left-[32%] absolute text-white font-bold text-opacity-5'>Features</p>
            <div className='flex lg:flex-row flex-col justify-between gap-[3rem] my-5 items-center'>
                <div data-aos="fade-down-right" className='z-[500] flex flex-col gap-11 w-full'>
                    <Feature1
                        header={"24/7 Equipment Monitoring"}
                        text={"On-site technicians providing round the clock support "}
                        img={"/Blockfarm/transparency.svg"}
                    />
                    <Feature1
                        header={"97% Uptime"}
                        text={"Industry leading uptime across all of facilities"}
                        img={"/Blockfarm/easy.svg"}
                    />
                    {/* <Feature1
                        header={"High Performance"}
                        text={"Ensuring farmers receive fair compensation for their labor and products."}
                        img={"/Blockfarm/performance.svg"}
                    /> */}
                </div>

                <img data-aos="flip-down" src="/Blockfarm/feature1.svg" alt="" />

                <div data-aos="fade-down-left" className='flex flex-col gap-11 justify-between w-full'>
                    <Feature2
                        header={"Cean Energy"}
                        text={"Our facilities operate on renewable energy sources, reducing the carbon footprint of your mining activities"}
                        img={"/Blockfarm/enhance.svg"}
                    />
                    <Feature2
                        header={"Low Power Cost"}
                        text={"we offer miner hosting for as low as $0.065 per kWh"}
                        img={"/Blockfarm/low.svg"}
                    />
                    {/* <Feature2
                        header={"OTA Update"}
                        text={"Foster a community of informed and engaged stakeholders."}
                        img={"/Blockfarm/ota.svg"}
                    /> */}
                </div>
            </div>

        </div>
    )
}

export default Features